import { FC } from "react";
import SourceDataItemValue, { ISourceDataItemValueProps } from "./SourceDataItemValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppSettings } from "@/AppSettings";
import { Box } from "@mui/material";

const SourceDataItemDateValue: FC<ISourceDataItemValueProps> = ({
    itemData,
    hideBorderStyles,
    hideStyles
}) => {
    return (
        <SourceDataItemValue
            hideBorderStyles={hideBorderStyles}
            hideStyles={hideStyles}
            startAdornment={
                <FontAwesomeIcon 
                    size="lg"
                    icon={AppSettings.icons.itemValueDate} 
                />
            }
        >
            {itemData?.value}
        </SourceDataItemValue>
    );
};

export default SourceDataItemDateValue;